<div class="dialog-content-wrapper">
  <mat-toolbar class="bg-primary m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{title}}</span>
      <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="form-padding m-0" fusePerfectScrollbar>
    <app-motivo-form></app-motivo-form>
  </div>
  <div mat-dialog-content class="btns-padding m-0" fusePerfectScrollbar>
    <div fxLayout="row" fxLayoutAlign="end end">
      <button class="mr-8" mat-raised-button matStepperPrevious type="button" (click)="dialogRef.close()">
        Cancelar
      </button>
      <button (click)="save()" [disabled]="!formValid" mat-raised-button matStepperNext type="button" color="accent">
        {{nameButonSaveOrUpdate}}
      </button>
    </div>
  </div>
</div>